import { render } from "./ProjectInfoTabView.vue?vue&type=template&id=24608a21"
import script from "./ProjectInfoTabView.vue?vue&type=script&lang=js"
export * from "./ProjectInfoTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__